import { render, staticRenderFns } from "./PeriodicReports.vue?vue&type=template&id=e07af0bc&scoped=true"
import script from "./PeriodicReports.vue?vue&type=script&lang=js"
export * from "./PeriodicReports.vue?vue&type=script&lang=js"
import style0 from "./PeriodicReports.vue?vue&type=style&index=0&id=e07af0bc&prod&scoped=true&lang=css"
import style1 from "./PeriodicReports.vue?vue&type=style&index=1&id=e07af0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07af0bc",
  null
  
)

export default component.exports